function _s(o, i, p, l) { void 0 === i && (i = 400), void 0 === l && (l = !1), o.style.overflow = "hidden", l && (o.style.display = "block"); var n, t = window.getComputedStyle(o), s = parseFloat(t.getPropertyValue("height")), a = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-bottom")), y = parseFloat(t.getPropertyValue("margin-top")), d = parseFloat(t.getPropertyValue("margin-bottom")), g = s / i, m = a / i, h = r / i, u = y / i, x = d / i; window.requestAnimationFrame(function t(e) { void 0 === n && (n = e); e -= n; l ? (o.style.height = g * e + "px", o.style.paddingTop = m * e + "px", o.style.paddingBottom = h * e + "px", o.style.marginTop = u * e + "px", o.style.marginBottom = x * e + "px") : (o.style.height = s - g * e + "px", o.style.paddingTop = a - m * e + "px", o.style.paddingBottom = r - h * e + "px", o.style.marginTop = y - u * e + "px", o.style.marginBottom = d - x * e + "px"), i <= e ? (o.style.height = "", o.style.paddingTop = "", o.style.paddingBottom = "", o.style.marginTop = "", o.style.marginBottom = "", o.style.overflow = "", l || (o.style.display = "none"), "function" == typeof p && p()) : window.requestAnimationFrame(t) }) } HTMLElement.prototype.slideToggle = function (t, e) { 0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e) }, HTMLElement.prototype.slideUp = function (t, e) { _s(this, t, e) }, HTMLElement.prototype.slideDown = function (t, e) { _s(this, t, e, !0) };


class MainProduct extends HTMLElement {
    constructor() {
        super();
        this.querySelector('.product-tabs') ? this.initTabs() : null;
    }

    initTabs() {
        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }

}

customElements.define('pleiades-template', MainProduct);